import { render } from "./WagerUserMilestonesDialog.vue?vue&type=template&id=e6a15782&scoped=true"
import script from "./WagerUserMilestonesDialog.vue?vue&type=script&lang=js"
export * from "./WagerUserMilestonesDialog.vue?vue&type=script&lang=js"

import "./WagerUserMilestonesDialog.vue?vue&type=style&index=0&id=e6a15782&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a15782"]])

export default __exports__